import { Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';

import { AccessControl } from '../../../components';
import { LeadAccess, useLeadAuthz } from '../../../hooks/useLeadAuthz';
import LeadDetails from '../components/leadDetails/LeadDetails';
import LeadForm from '../components/LeadForm';
import LeadList from '../components/LeadList';
import LeadStatus from '../components/leadStatus/LeadStatus';

const LeadsRoutes = () => {
  const isAuthorizedViewLeadListing = useLeadAuthz(LeadAccess.VIEW_LEAD_LISTING_ALL);
  const isAuthorizedAddLead = useLeadAuthz(LeadAccess.ADD_LEAD_DETAILS);
  const isAuthroizedEditLeadDetails = useLeadAuthz(LeadAccess.EDIT_LEAD_DETAILS);

  const AccessRestricted = (
    <Box mt={2}>
      <AccessControl />
    </Box>
  );

  return (
    <Routes>
      <Route path="" element={isAuthorizedViewLeadListing ? <LeadList /> : AccessRestricted} />
      <Route path="/add" element={isAuthorizedAddLead ? <LeadForm /> : AccessRestricted} />
      <Route path="/details" element={<LeadDetails />} />
      <Route
        path=":leadId/edit"
        element={isAuthroizedEditLeadDetails ? <LeadForm /> : AccessRestricted}
      />
      <Route path="/lead-status" element={<LeadStatus />} />
    </Routes>
  );
};

export default LeadsRoutes;
